import axios from "axios";

import errorHandler from "./errorHandler";

// The API keeps the session in an httpOnly cookie (set by POST /auth/login
// or /auth/register), so every call just sends cookies along. No tokens in JS.
const client = axios.create({
  baseURL: `${process.env.REACT_APP_API_HOST}`,
  withCredentials: true,
});

client.interceptors.response.use((response) => response.data, errorHandler);

export default client;
